import { forwardRef, type PropsWithChildren } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLayout } from '../layout-context';

export const SnapCarouselWrapper = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ component: string }>
>(({ children, component }, ref) => {
  const {
    breakpoints: { isMediumBreakpoint },
    snapCarouselMargins: { left, right }
  } = useLayout();

  return (
    <Wrapper
      ref={ref}
      className={createReadableClass(
        {
          component,
          element: 'snap-carousel-wrapper'
        },
        ['es-layout-component']
      )}
      $isDesktopLayout={!isMediumBreakpoint}
      $marginLeft={left}
      $marginRight={right}
    >
      {children}
    </Wrapper>
  );
});

const Wrapper = styled.div.attrs<{
  $isDesktopLayout: boolean;
  $marginLeft?: number;
  $marginRight?: number;
}>(({ $isDesktopLayout, $marginLeft, $marginRight }) => ({
  style: $isDesktopLayout
    ? {
        marginLeft: $marginLeft,
        marginRight: $marginRight
      }
    : {}
}))`
  position: relative;
`;
